// https://material-ui.com/pt/customization/default-theme/
import React from "react";
import { ThemeProvider } from "styled-components";

const theme = {
  palette: {
    primary: "#0c2d6a",
    secondary: "#d6e5ff",
    tertiary: "#AFB9C8",
    black: "#2b2b2b",
    white: "white",
    gray: "#858585",
    subGray: "#e0e0e0",
    orange: "#fc9d03",
    green: "#7FC8A9",
    diminutegreen: "#bcdccf",
    darkGreen: "#008000",
    red: "#FA8072",
    redSecondary: "#F55C47",
    blue: "#0F52BA",
    bluePrimary: "#ebf2ff",
    blueLight: "#8d99ab",
    light: {
      grey: "#DDDDDD",
      subgrey: "#EEEEEE",
      purple: "#E8E1FF",
    },
    transparent: "transparent",
  },
  fonts: {
    mulish: "Mulish",
    comfortaa: "Comfortaa",
    montserrat: "Montserrat",
    helvetica: "Helvetica",
    mohave: "Mohave",
    opensans: "Open Sans",
  },
  spacing: (multiplier) => 8 * multiplier + "px",
};

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;
